import realpressHalfMap from './shortcode/half-map/half-map';
import realpressSwitchLayout from './shortcode/half-map/switch-layout';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressHalfMap();
	realpressSwitchLayout();
} );
